import React, { useEffect, useState } from "react";
import "../css/PanneauInfoSupplementairesEtablissement.css";
import { getFinessInformation } from "./Fonctions_Communications_API";
import { envoyerEmailOuVerification } from "./VerifierEmail";

const SelectOptionBool = ({
	label,
	name,
	lien,
	value,
	handleModifierEtablissement,
}) => (
	<div className="select-option-modif-infosupp">
		{lien ? (
			<a href={lien} className="select-label-modif-infosupp" target="_blank" rel="noopener noreferrer">
				{label}
			</a>
			) : (
			<label className="select-label-modif-infosupp">{label}</label>
			)}
		<select
			className="select-field-modif-infosupp"
			value={value === null ? "" : value.toString()}
			onChange={(e) => {
				const newValue =
					e.target.value === "" ? null : e.target.value === "true";
				handleModifierEtablissement(name, newValue);
			}}>
			<option value=""> </option>
			<option value="true">Oui</option>
			<option value="false">Non</option>
		</select>
	</div>
);

const SelectOptionCategories = ({
	label,
	name,
	lien,
	value,
	dicovalues,
	handleModifierEtablissement,
}) => (
	
	<div className="select-option-modif-infosupp">
		{lien ? (
			<a href={lien} className="select-label-modif-infosupp" target="_blank" rel="noopener noreferrer">
				{label}
			</a>
			) : (
			<label className="select-label-modif-infosupp">{label}</label>
			)}
		<select
			className="select-field-modif-infosupp"
			value={value === null ? "" : value}
			onChange={(e) => {
				const newValue = e.target.value === "" ? null : e.target.value;
				handleModifierEtablissement(name, newValue);
			}}>
			<option value="">-- Sélectionnez une option --</option>{" "}
			{Object.entries(dicovalues).map(([key, val]) => (
				<option key={key} value={key}>
					{val}
				</option>
			))}
		</select>
	</div>
);

const EditableInput = ({ label, name, lien, value, handleModifierEtablissement }) => (
	<div className="select-option-modif-infosupp">
		{lien ? (
			<a href={lien} className="select-label-modif-infosupp" target="_blank" rel="noopener noreferrer">
				{label}
			</a>
			) : (
			<label className="select-label-modif-infosupp">{label}</label>
			)}
		<input
			type="text"
			className="select-editable-modif-infosupp"
			value={value === null ? "" : value.toString()}
			onChange={(e) => {
				const newValue = e.target.value === "" ? null : e.target.value;
				handleModifierEtablissement(name, newValue);
			}}
		/>
	</div>
);

const NumericSelect = ({
	label,
	name,
	value,
	handleModifierEtablissement,
	max = 1000,
}) => {
	return (
		<div className="select-option-modif-infosupp">
			<label className="select-label-modif-infosupp">{label}</label>
			<select
				className="select-field-modif-infosupp"
				name={name}
				value={value === null ? "" : value}
				onChange={(e) => {
					const newValue = e.target.value === "" ? null : e.target.value;
					handleModifierEtablissement(name, newValue);
				}}>
				<option value=""> </option>
				{[...Array(max + 1).keys()].map((num) => (
					<option key={num} value={num}>
						{num}
					</option>
				))}
			</select>
		</div>
	);
};

const push_modif = async (
	etablissementAModifier,
	setEtablissementAModifier,
	email,
	setShowThankYouModal,
	setAfficherPanneauInfoSupplementaires,
	setUtilisateurSouhaiteModifier
) => {
	try {
		//const [lat, lon] = await rechercher_coordonnées(etablissementAModifier, setEtablissementAModifier);

		const payload = {
			...etablissementAModifier,
			email,
		};
		const lat = etablissementAModifier.latitude;
		const lon = etablissementAModifier.longitude;

		const response = await fetch(
			`https://carto.api.toobib.org/api/upsert_finess_modifications?lat=${lat}&lon=${lon}&email=${email}`,
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(payload),
			}
		);

		if (!response.ok) {
			throw new Error(
				`Error updating finess_modifications: ${response.statusText}`
			);
		}

		const data = await response.json();
		console.log("Data successfully updated:", data);

		setUtilisateurSouhaiteModifier(false);
		setAfficherPanneauInfoSupplementaires(false);

		setShowThankYouModal(true);
	} catch (err) {
		console.error("Error pushing modifications:", err);
	}
};

export const PanneauInfoSupplementairesEtablissement = ({
	afficherPanneauInfoSupplementaires,
	setAfficherPanneauInfoSupplementaires,
	numeroFiness,
	setShowThankYouModal,
}) => {
	const [data, setData] = useState(null);

	useEffect(() => {
		const fetchData = async () => {
			if (numeroFiness) {
				await getFinessInformation(numeroFiness, setData);
			}
		};
		fetchData();
	}, [numeroFiness]);

	
	const [showContact, setShowContact] = useState(false);
	const [showEquipements, setShowEquipements] = useState(false);
	const [showActivites, setShowActivites] = useState(false);
	const [showAdministratif, setShowAdministratif] = useState(false);
	const [showOther, setShowOther] = useState(false);
	const [showOSM, setShowOSM] = useState(false);

	const [utilisateurSouhaiteModifier, setUtilisateurSouhaiteModifier] =
		useState(false);
	const [etablissementAModifier, setEtablissementAModifier] = useState(null);
	useEffect(() => {
		setEtablissementAModifier(data);
	}, [data]);

	const handleModifierEtablissement = (key, value) => {
		setEtablissementAModifier((prevData) => ({ ...prevData, [key]: value }));
	};

	const handleSaveEtablissement = () => {
		push_modif(
			etablissementAModifier,
			setEtablissementAModifier,
			email,
			setShowThankYouModal,
			setAfficherPanneauInfoSupplementaires,
			setUtilisateurSouhaiteModifier
		);
	};

	const [email, setEmail] = useState(null);
	const [modifPermise, setModifPermise] = useState(false);
	const [emailsVerifies, setEmailVerifies] = useState([]);

	useEffect(() => {
		emailsVerifies.includes(email)
			? setModifPermise(true)
			: setModifPermise(false);
	}, [emailsVerifies, email]);
	useEffect(() => {
		let intervalId;

		const fetchEmails = async () => {
			try {
				const response = await fetch(
					"https://carto.api.toobib.org/api/get_verified_emails"
				);

				if (!response.ok) {
					throw new Error("Failed to fetch verified emails");
				}

				const data = await response.json();
				setEmailVerifies(data);
			} catch (error) {
				console.error("Error fetching verified emails:", error);
			}
		};

		if (afficherPanneauInfoSupplementaires && !utilisateurSouhaiteModifier) {
			intervalId = setInterval(fetchEmails, 2000);
			fetchEmails();
		}

		return () => {
			if (intervalId) {
				clearInterval(intervalId);
			}
		};
	}, [afficherPanneauInfoSupplementaires, utilisateurSouhaiteModifier]);

	


	const fields = {
		// Contact (ces informations ne sont pas modifiables)
		adresse_finale: {nom: "Adresse", type: "text", categorie: "contact", img: "adresse_blanc.png"},
		telephone: {nom: "Numéro de téléphone", type: "text", categorie: "contact", img: "contact_telephone.png"},
		telecopie: {nom: "Numéro de FAX", type: "text", categorie: "contact", img: "fax.png"},
		sous_categorie: {nom: "Sous-catégorie", type: "text", categorie: "contact", img: "menu_blanc.png"},
		categories: {nom: "Catégorie", type: "categ-contact", categorie: "contact", img: "lieu.png"},
		
		// Equipements et capacité
		equipement_handicap_adultes: {nom: "Equipement Handicap Adulte", type: "bool", categorie: "equipement"},
		equipement_handicap_enfants: {nom: "Equipement Handicap Enfant", type: "bool", categorie: "equipement"},
		equipement_personnes_agees: {nom: "Equipement Personnes Agées", type: "bool", categorie: "equipement"},
		capacité_totale: {nom: "Capacité totale", type: "number", categorie: "equipement"},
		capacité_hébergement: {nom: "Capacité d'hébergement", type: "number", categorie: "equipement"},
		nombre_irm: {nom: "Nombre d'IRM", type: "number", categorie: "equipement", img: "irm.png"},
		nombre_scanner: {nom: "Nombre de scanners", type: "number", categorie: "equipement", img: "irm.png"},
		
		// Activités
		activite: {categorie: "activite"},

		// Informations administratives
		finess_ej: {nom: "Numéro de Finess EJ", type: "text_fixed", categorie: "administratif"},
		finess_et: {nom: "Numéro de Finess ET", type: "text_fixed", categorie: "administratif"},
		siren: {nom: "Numéro de SIREN", type: "text", categorie: "administratif"},
		fixation_tarifs: {nom: "Fixation des Tarifs", type: "text", categorie: "administratif"},
		participation_service_public_hospitalier: {nom: "Participation au Service Public Hospitalier", type: "text", categorie: "administratif"},

		// Informations diverses
		site_web: {nom: "Site web", type: "hyperlien", categorie: "other"},
		acces_pmr: {nom: "Accès PMR", type: "bool", categorie: "other"},
		etage: {nom: "Etage", type: "number", categorie: "other"},
		lien_santefr: {nom: "Lien santé.fr", type: "hyperlien", categorie: "other", lien:"https://www.sante.fr/"},
		naf: {nom: "Code NAF", type: "text", categorie: "other"},
		annuaire_entreprises: {nom: "Lien annuaire entreprises", type: "hyperlien", categorie: "other", lien:"https://annuaire-entreprises.data.gouv.fr/"},
		healthsites: {nom: "Healthsites", type: "hyperlien", categorie: "other", lien:"https://healthsites.io"},

		// Infos OpenStreetMap
		amenity: {nom: "Amenity", type: "possibilite", categorie: "osm", lien:"https://wiki.openstreetmap.org/wiki/FR:Key:amenity"},
		healthcare: {nom: "Healthcare", type: "possibilite", categorie: "osm", lien:"https://wiki.openstreetmap.org/wiki/FR:Key:healthcare"},
		healthcare_specialty: {nom: "Healthcare Specialty", type: "possibilite", categorie: "osm", lien:"https://wiki.openstreetmap.org/wiki/FR:Key:healthcare:speciality"},
		dispensing: {nom: "Dispensing", type: "bool", categorie: "osm", lien:"https://wiki.openstreetmap.org/wiki/FR:Key:dispensing"},
		social_facility: {nom: "Social Facility", type: "possibilite", categorie: "osm", lien:"https://wiki.openstreetmap.org/wiki/FR:Key:social_facility"},
		social_facility_for: {nom: "Social Facility For", type: "possibilite", categorie: "osm", lien:"https://wiki.openstreetmap.org/wiki/FR:Key:social_facility:for"},
	}

	const categoryStates = [
		{ key: "contact", name: "Contact", show: showContact, setShow: setShowContact },
		{ key: "equipement", name: "Equipements & Capacité", show: showEquipements, setShow: setShowEquipements },
		{ key: "activite", name: "Activités", show: showActivites, setShow: setShowActivites },
		{ key: "administratif", name: "Informations Administratives", show: showAdministratif, setShow: setShowAdministratif },
		{ key: "other", name: "Informations Diverses", show: showOther, setShow: setShowOther },
		{ key: "osm", name: "OpenStreetMap", show: showOSM, setShow: setShowOSM },
	  ];

	const valeurs_attributs_categoriels = {
		"Activités": {
			activite_sanitaire: "Activité Sanitaire",
			chirurgie: "Chirurgie",
			dialyse: "Dialyse",
			gyneco_obstetrique_neonatal: "Gynécologie, Obstétrique, Néonatalogie",
			hospitalisation_domicile: "Hospitalisation à Domicile",
			medecine: "Médecine",
			psychiatrie: "Psychiatrie",
			service_readaptation: "Service de Réadaptation",
			soins_critiques: "Soins Critiques",
			soins_longue_duree: "Soins de Longue Durée",
			traitement_cancer: "Traitement des Cancers",
			urgences: "Urgences",
		},
		"Amenity": {
			first_aid_school: "Espace de formation aux premiers secours",
			kindergarten: "Établissement de garde d'enfants",
			research_institute: "Institut de recherche",
			school: "Ecole",
			university: "Université, campus universitaire",
			clinic: "Clinique",
			dentist: "Dentiste",
			doctors: "Cabinet médical",
			hospital: "Hôpital",
			pharmacy: "Pharmacie",
			social_facility: "Services sociaux",
			courthouse: "Palais de justice",
			prison: "Prison",
		},
		"Healthcare": {
			alternative: "Thérapie alternative",
			audiologist: "Audiologie",
			birthing_centre: "Maison de naissance",
			blood_bank: "Banque du sang",
			blood_donation: "Centre de don du sang",
			centre: "Maison médicale, centre de consultations",
			clinic: "Clinique ou Polyclinique",
			dentist: "Dentiste", // uniquement si amenity=dentist
			doctor: "Cabinet médical", // uniquement si amenity=doctors
			hospital: "Hôpital", // uniquement si amenity=hospital
			nurse: "Soins infirmiers",
			medical_spa: "Établissement thermal",
			laboratory: "Laboratoire de biologie médicale",
			midwife: "Maïeutique",
			occupational_therapist: "Ergothérapie",
			optometrist: "Orthoptie",
			pharmacy: "Pharmacie", // uniquement si amenity=pharmacy
			physiotherapist: "Physiothérapie, Kinésithérapie",
			podiatrist: "Podologie",
			psychotherapist: "Psychologie, Psychothérapie",
			rehabilitation: "Centre de rééducation médicale",
			speech_therapist: "Orthophonie",
			yes: "Autre",
		},
		"Healthcare Specialty": {
			allergology: "Allergologie",
			anaesthetics: "Anesthésie",
			cardiology: "Cardiologie",
			cardiothoracic_surgery: "Chirurgie cardiothoracique",
			child_psychiatry: "Pédopsychiatrie",
			community: "Santé publique",
			dermatology: "Dermatologie",
			dermatovenereology: "Dermato-vénérologie",
			diagnostic_radiology: "Radiologie, Imagerie Médicale",
			emergency: "Médecine d'urgence",
			endocrinology: "Endocrinologie",
			gastroenterology: "Gastro-entérologie",
			general: "Médecine générale",
			geriatrics: "Gériatrie",
			gynaecology: "Gynécologie",
			haematology: "Hématologie",
			hepatology: "Hépatologie",
			infectious_diseases: "Maladies infectieuses",
			intensive: "Soins intensifs",
			internal: "Médecine interne",
			dental_oral_maxillo_facial_surgery: "Chirurgie dentaire",
			neonatology: "Néonatalogie",
			nephrology: "Néphrologie",
			neurology: "Neurologie",
			neuropsychiatry: "Neuropsychiatrie",
			neurosurgery: "Neurochirurgie",
			nuclear: "Médecine nucléaire",
			occupational: "Médecine du travail",
			oncology: "Oncologie",
			ophthalmology: "Ophtalmologie",
			orthodontics: "Orthodontie",
			orthopaedics: "Chirurgie orthopédique",
			otolaryngology: "Otorhinolaryngologie (ORL)",
			paediatric_surgery: "Chirurgie pédiatrique",
			paediatrics: "Pédiatrie",
			palliative: "Soins palliatifs",
			pathology: "Histopathologie",
			physiatry: "Médecine du sport & Rééducation",
			plastic_surgery: "Chirurgie plastique",
			podiatry: "Podologie",
			proctology: "Proctologie",
			psychiatry: "Psychiatrie",
			pulmonology: "Pneumologie",
			radiology: "Radiologie",
			radiotherapy: "Radiothérapie",
			rheumatology: "Rhumatologie",
			stomatology: "Stomatologie",
			surgery: "Chirurgie générale",
			transplant: "Transplantations",
			trauma: "Traumatologie",
			tropical: "Médecine tropicale",
			urology: "Urologie",
			vascular_surgery: "Chirurgie vasculaire",
			venereology: "Vénérologie",
		},

		"Social Facility": {
			group_home: "Lieu de résidence collective",
			assisted_living: "Lieu de résidence collective autonomie",
			nursing_home: "Maison de soins infirmiers",
			shelter: "Refuge ou hébergement d'urgence",
			ambulatory_care: "Structure de soins ambulatoires",
			outreach: "Service de conseil et d'aide sociale",
			workshop: "Lieu de travail non résidentiel",
			food_bank: "Banque alimentaire",
		},
		"Social Facility For": {
			abused: "Victimes d'abus sexuels",
			child: "Enfants",
			disabled: "Personnes handicapées physiques",
			diseased: "Malades et leur familles",
			drug_addicted: "Toxicomanes",
			homeless: "Sans abris",
			juvenile: "Jeunes",
			mental_health: "Problèmes mentaux ou psychologiques",
			migrant: "Migrants, réfugiés",
			orphan: "Orphelins",
			senior: "Personnes âgées",
			underprivileged: "Personnes démunies",
			unemployed: "Personnes sans emploi",
			victim: "Victimes de crimes",
		},
	};

	const renderFieldsByCategory = (categorie, data, fields) => {
		
		return Object.entries(fields).filter(([_, field]) => field.categorie === categorie).map(([key, field]) => {
			const value = data[key];
			
			if (key === "activite") {
				return (
					<div className="activite-ligne-infosupp">
						{Object.keys(valeurs_attributs_categoriels["Activités"]).map(
							(activite) => data[activite] && (
								<span className="activite-infosupp">
									{valeurs_attributs_categoriels["Activités"][activite]}
								</span>
							)
						)}
					</div>
				)
			}
			
			else if (value === undefined || value === null || value === "" || (Array.isArray(value) && value.length === 0)) {
			  return null; // Ignore les valeurs vides
			}

			if (field.type === "bool") {
			  return (
				<div key={key} className="ligne-infosupp">
				  <div className="logo-infosupp">
					<img style={{ width: "20px", height: "20px" }} src={value ? "in.png" : "not-in.png"} alt="in_or_not" />
				  </div>
				  <div className="nom-infosupp">					
					<span>{field.nom}</span>
				  </div>
				</div>
			  );
			}
			else if (field.type === "categ-contact") {
				return (
					<div>
						<div className="liste-categories-infosupp">
							{data.categories.map((categorie) => (
								<span className="bubble-categorie-infosupp">
									{categorie}
								</span>
							))}
						</div>
					</div>
				)
			}
			else if (field.type === "hyperlien"){
				return (
					<div key={key} className="ligne-infosupp">
					  <div className="logo-infosupp">
						<img style={{ width: "20px", height: "20px" }} src={field.img || "ecriture.png"}  alt={field.name} />
					  </div>
					  <div className="nom-infosupp">
						  
					  <span>
						{field.nom} :{" "}
						<a href={value} target="_blank" rel="noopener noreferrer" style={{ color: "white" }}>
						{value}
						</a>
					</span>
					  </div>
					</div>
				  );
			}
			return (
			  <div key={key} className="ligne-infosupp">
				<div className="logo-infosupp">
				  <img style={{ width: "20px", height: "20px" }} src={field.img || "ecriture.png"}  alt={field.name} />
				</div>
				<div className="nom-infosupp">
					
				<span>{field.nom} : {field.type === "possibilite" ? valeurs_attributs_categoriels[field.nom][value] : value}</span>
				</div>
			  </div>
			);
		  });
	  };
	  
	// console.log("Data:", data)
	// console.log("Etab_modif:", etablissementAModifier)
	  const ComponentAffichageInfosCategorie = () => {
		return (
		  <div>
			{categoryStates.map(({ key, name, show, setShow }) => {
			  // On filtre les champs de la catégorie pour vérifier s'il y a des données à afficher
			  const hasData = Object.entries(fields)
				.filter(([_, field]) => field.categorie === key)
				.some(([key]) => data[key] != null && data[key] !== undefined &&data[key]!=="" && (Array.isArray(data[key]) ? data[key].length > 0 : true));
	  
			  // Si aucune donnée n'est présente dans la catégorie, on ne rend pas le bouton
			  if (!hasData) return null;
			  return (
				<div key={key}>
				  <button className="nom-onglet-infosupp" onClick={() => setShow(!show)}>
					<span>{name}</span>
				  </button>
				  {show && (
					<div>{renderFieldsByCategory(key, data, fields)}</div>
				  )}
				</div>
			  );
			})}
		  </div>
		);
	  };

	// Supprimer les doublons éventuels dans la liste data.categories
	if (data && data.categories) {data.categories = [...new Set(data.categories)];}
	if (!data) return null;
	if (!utilisateurSouhaiteModifier) {
		return (
			<div
				className={`panneau-gauche-infosupp ${
					afficherPanneauInfoSupplementaires ? "visible" : ""
				}`}>
				<button
					className="bouton-infosupp"
					onClick={() => setAfficherPanneauInfoSupplementaires(false)}>
					<span className="icon-croix-infosupp">×</span>
				</button>

				<div className="surtitre-infosupp">
					<p>Informations supplémentaires</p>
				</div>
				<div className="titre-infosupp">
					<p>{data.rs}</p>
				</div>

				<div className="infos-infosupp">
					{ComponentAffichageInfosCategorie()}
				</div> 
				<button
					disabled={!modifPermise}
					title={
						modifPermise
							? "Modifier les infos de cet établissement"
							: "Vous devez d'abord valider votre adresse email"
					}
					className="valider-modif-infosupp-button"
					
					onClick={() => setUtilisateurSouhaiteModifier(true)}>
					
					Modifier
				</button>
				<div className="verifier-adresse-email">
					<input
						type="email"
						placeholder="Adresse email"
						className="edit-input"
						value={email}
						onChange={(e) => setEmail(e.target.value)}
					/>
					<button
						type="button"
						disabled={modifPermise}
						className="pop-up_modif_touchable"
						onClick={() =>
							envoyerEmailOuVerification(email, null, "verification")
						}
						style={{ color: "white", marginTop: "0px" }}>
						{!modifPermise
							? "Vérifier mon email"
							: "Votre email est déjà vérifié"}
					</button>
				</div>
			</div>
		);
	} else {
		return (
			<div
				className={`panneau-gauche-infosupp ${
					afficherPanneauInfoSupplementaires ? "visible" : ""
				}`}>
				<button
					className="bouton-infosupp"
					onClick={() => {
						setAfficherPanneauInfoSupplementaires(false);
						setTimeout(() => {
							setUtilisateurSouhaiteModifier(false);
						}, 1000);
					}}>
					<span className="icon-croix-infosupp">×</span>
				</button>
				
				<div className="titre-modif-infosupp">
					<span>Modification des informations supplémentaires</span>
				</div>
				<div className="modif-infosupp">
					{Object.keys(fields)
					.filter((key) => (fields[key].categorie !== "contact"||fields[key].nom==="Numéro de FAX") && fields[key].categorie !== "activite")
					.map((key) => {
						const field = fields[key];

						switch (field.type) {
							case "bool":
								return (
									<SelectOptionBool
										label={field.nom + " :"}
										name={key}
										lien={field.lien ?? null}
										value={etablissementAModifier[key]}
										handleModifierEtablissement={handleModifierEtablissement}
									/>
								);

							case "text":
								return (
									<EditableInput
										label={field.nom + " :"}
										name={key}
										value={etablissementAModifier[key]}
										handleModifierEtablissement={handleModifierEtablissement}
									/>
								);

							case 'hyperlien':
								return (
									<EditableInput
										label={field.nom + " :"}
										name={key}
										lien={field.lien ?? null}
										value={etablissementAModifier[key]}
										handleModifierEtablissement={handleModifierEtablissement}
									/>
								);

							case "number":
								return (
									<NumericSelect
										label={field.nom + " :"}
										name={key}
										value={etablissementAModifier[key]}
										handleModifierEtablissement={handleModifierEtablissement}
									/>
								);

							case "possibilite":
								
								return (
									<SelectOptionCategories
										label={field.nom + " :"}
										name={key}
										lien={field.lien ?? null}
										value={etablissementAModifier[key]}
										dicovalues={valeurs_attributs_categoriels[field.nom]}
										handleModifierEtablissement={handleModifierEtablissement}
									/>
								);
							}
						})}
					<button
						className="valider-modif-infosupp-button"
						style={{ bottom: "3%" }}
						onClick={handleSaveEtablissement}>
						Enregistrer les modifications
					</button>
				</div>
				
			</div>
		);
	}
};
